module.exports = __webpack_public_path__ + "img/shopping_cart.f99ea787.png";